export const MIN_CREDIT_HOURS = 1;
export const MAX_CREDIT_HOURS = 6;
